// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import React from 'react';
import RegionalOrderAvailability from './regional-order-availability';

function RegionalOrderAvailabilityPage () {

    return (
        <AuthenticatedPage className="atp-page atp-regional-order-availability-page">
            <RegionalOrderAvailability />
        </AuthenticatedPage>
    );

}
RegionalOrderAvailabilityPage.displayNAme = 'RegionalOrderAvailabilityPage';

export default RegionalOrderAvailabilityPage;
